import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { http } from "@/lib/api";
import { RecordShell } from "@/components/records/RecordShell";

export default function EnrollmentLetter() {
  const { studentId } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { http.get(`/students/${studentId}/enrollment`).then((r) => setD(r.data)); }, [studentId]);
  if (!d) return <div className="py-20 text-center text-stone-500">Loading…</div>;
  const today = new Date(d.generated_at).toLocaleDateString([], { month: "long", day: "numeric", year: "numeric" });
  return (
    <RecordShell title="Proof of Enrollment" back testId="enrollment-page">
      <div className="mt-8 space-y-4 text-stone-700 leading-relaxed" data-testid="enrollment-letter">
        <p>{today}</p>
        <p>To whom it may concern,</p>
        <p>This letter confirms that <b data-testid="enrollment-name">{d.student.name}</b> is currently <b data-testid="enrollment-status">{d.status.toLowerCase()}</b> in ConsciousLearn ({d.edition}), a consciousness-based, {d.state_name} standards-aligned K-12 program, in <b>{d.student.grade_label}</b>.</p>
        <p>Enrollment date: <b data-testid="enrollment-date">{d.enrolled_on}</b>{d.first_activity && <> · First recorded learning day: <b>{d.first_activity}</b></>}.</p>
        {d.classes.length > 0 && <p>Classes: {d.classes.map((c) => `${c.name}${c.teacher ? ` (${c.teacher})` : ""}`).join("; ")}.</p>}
        {d.parents.length > 0 && <p>Parent/guardian on record: {d.parents.join(", ")}.</p>}
        <p>Attendance (active seat-time), grades and transcripts are maintained in the learner's official record and are available on request.</p>
        <div className="pt-10 grid grid-cols-2 gap-10 text-sm"><p className="border-t border-stone-400 pt-2">Administrator signature</p><p className="border-t border-stone-400 pt-2">Date</p></div>
      </div>
    </RecordShell>
  );
}
